<div style="display: flex; justify-content: space-between;">
  <h2>{{data.soOrderDate | date:'yyyy-MM-dd'}} {{data.soAssignmentNo}}</h2>

  <button matIconButton (click)="close()" matTooltip="Stäng">
    <mat-icon>close</mat-icon>
  </button>
</div>

<p  style="font-size: large; font-weight: 500; margin-bottom: 5px;">Uppdragstext</p>
@for (aText of assignmentTexts; track aText) {
  <mat-card appearance="outlined" style="margin-bottom: 5px;">
    <mat-card-content style="padding-top: 0px; padding-bottom: 0px;">
      <mat-nav-list>
        <div class="header" style="font-size: 14px;">
          {{aText?.soeModifyDate | date:'yyyy-MM-dd HH:mm'}} | {{aText?.soeModifier | employeeCodeTrim}}
        </div>
        <div class="pre-line">{{aText?.soeText}}</div>
      </mat-nav-list>
    </mat-card-content>
  </mat-card>
}


@if (internTexts.length > 0) {
  <p  style="font-size: large; font-weight: 500; margin-bottom: 5px;">Interntext</p>
  @for (iText of internTexts; track iText) {
    <mat-card appearance="outlined" style="margin-bottom: 5px;">
      <mat-card-content style="padding-top: 0px; padding-bottom: 0px;">
        <mat-nav-list>
          <div class="header" style="font-size: 14px;">
            {{iText?.soeModifyDate | date:'yyyy-MM-dd HH:mm'}} | {{iText?.soeModifier | employeeCodeTrim}}
          </div>
          <div class="pre-line">{{iText?.soeText}}</div>
        </mat-nav-list>
      </mat-card-content>
    </mat-card>
  }
}

@if (reasons.length > 0) {
  <p  style="font-size: large; font-weight: 500; margin-bottom: 5px;">Orsak</p>
  @for (r of reasons; track r) {
    <mat-card appearance="outlined" style="margin-bottom: 5px;">
      <mat-card-content style="padding-top: 0px; padding-bottom: 0px;">
        <mat-nav-list>
          <div class="header" style="font-size: 14px;">
            {{r?.soeModifyDate | date:'yyyy-MM-dd HH:mm'}} | {{r?.soeModifier | employeeCodeTrim}}
          </div>
          {{r?.soeText}}
        </mat-nav-list>
      </mat-card-content>
    </mat-card>
  }
}

@if (actions.length > 0) {
  <p  style="font-size: large; font-weight: 500; margin-bottom: 5px;">Åtgärd</p>
  @for (a of actions; track a) {
    <mat-card appearance="outlined" style="margin-bottom: 5px;">
      <mat-card-content style="padding-top: 0px; padding-bottom: 0px;">
        <mat-nav-list>
          <div class="header" style="font-size: 14px;">
            {{a?.soeModifyDate | date:'yyyy-MM-dd HH:mm'}} | {{a?.soeModifier | employeeCodeTrim}}
          </div>
          {{a?.soeText}}
        </mat-nav-list>
      </mat-card-content>
    </mat-card>
  }
}
